import { createZodDto } from 'nestjs-zod/dto';
import { CommonMemberCreateSchema } from '#web-service-api/member/create';
import { AcceptIndividualInvitationSchema } from './accept-individual-invitation.dto';
export const AcceptOrganizationInvitationSchema = CommonMemberCreateSchema.extend(AcceptIndividualInvitationSchema.shape);
export class AcceptOrganizationInvitationDto extends createZodDto(AcceptOrganizationInvitationSchema) {
}
